import React, { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { BsStarFill, BsCameraFill, BsCircleFill } from 'react-icons/bs'
import { Row, Col, Container } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive'
import CartAction from '../redux/actions/CartAction';
import OrderAction from '../redux/actions/OrderAction';
import { useSelector, useDispatch } from "react-redux";
import { IoStarSharp } from "react-icons/io5";
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
const RatedProduct = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 991px)'
  })
  const dispatch = useDispatch()
  const { saveRating ,} = CartAction();
  const myorders = useSelector(state => state.orderdetail.myorders);
  const ratingdata = useSelector(state => state.masterdata.ratingdata);
  // const pid=myorders.map(ele=>ele).ele.order_details.map(ele1=>ele1.productid);
  // useEffect(() => {
  //   dispatch(saveRating());
  // }, []);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [message, setMessage] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]);
  const [ratingproduct,setratingproduct]=useState("")
  const [error,SetError]=useState(
    {
      ratingproduct:""
    }
  )
  const handleImageChange = (e) => {
    const files = e.target.files;
    const selectedFiles = Array.from(files);

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      if (file.size > 200 * 1024) {
        setMessage(true)
        break;
      } else {
        setSelectedImages((prevImages) => [...prevImages, file]);
        setMessage(false)
      }
    }
  };


  
  const removeImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);

    setSelectedImages(updatedImages);
  };
  const removeimages = () => {

    setSelectedImages(!selectedImages)
  }

  
  const handleRating = (value) => {
    setRating(value);
  };
  const [image, setImage] = useState([]);
  const [imagedata, setImagedata] = useState([]);
  // useEffect (()=>{
  //   saveRating();
  // },[]);
  var selectedFile;
  let file;
  let previews = [];
  //   const handleImageChange = (e) => {
  // selectedFile = e.target.files;

  //     setImagedata(selectedFile);
  //     for (let i = 0; i < selectedFile.length; i++) {
  //        file = selectedFile[i];
  //       const url = URL.createObjectURL(file);
  //       previews.push(url);
  //       if (selectedFile.length >5){
  //         alert("maxium allowed five images");
  //         break;

  //       }



  //       setImage(previews);

  //     }

  //   };
  const handleRemoveImages = () => {


    setImage(!previews);


  };
  // const imagewrong =(event)=>{
  //   const selectedFile = event.target.files[1];
  //   setImage(selectedFile)
  // }
  const handleComment = (e) => {
    setComment(e.target.value);
  };

  // const handleRatingtitle=(e)=>{
  //   setTitleComment(e.target.value);
  // }
  const handleSubmit = (e) => {

    {
     if(rating == 0 ) {
      SetError({...error,ratingproduct:"(Rating is required)"})
     }
     
      else{
        e.preventDefault();
        const formData = new FormData();
        formData.append('rating', rating);
        formData.append('review', comment);
        formData.append('orderId', ratingdata.id);
        formData.append('productid', ratingdata.productid);
        formData.append('rstatus',  localStorage.getItem("review_flag"));

        for (let i = 0; i < selectedImages.length; i++) {
    
          formData.append('image[]', selectedImages[i]);
    
    
        }
        SetError({...error,ratingproduct:""})
        // formData.append('image', imagedata[-1])
    
        // let add=[]
        // for (let i = 0; i < imagedata.length; i++) {
        //   add.push(imagedata[i]);
        // }
        // formData.append('image', add);
        setRating();
        // setratingproduct("rating is must and should");
        setComment('');
        // setTitleComment('');
        setImage([]);
    
        dispatch(saveRating(formData));
        setSelectedImages([]);
      }
      }
    
      
   
  
  };




  const navigate = useNavigate();

  useEffect(() => {
    if (Object.keys(ratingdata).length <= 0) {
      navigate('/my-orders');
    }
  }, [ratingdata]);
  return (
    <Container fluid>
      <Row className='title-and-image'>
      <Col lg={3} md={12}  className='rating-reviw-title-main-div'>
        
        <h1 className='rating-review'>Ratings & Reviews</h1>
       
        </Col>
        {
              (Object.keys(ratingdata).length > 0) &&
              <Col lg={9} md={12} className='rated-image-maindiv'>
      
              <div>
                <NavLink to={`/product/${ratingdata.productdata[0].slug}`}>
                <img  referrerPolicy="no-referrer"  className='ratedimage' src={localStorage.getItem("cdn") + ratingdata.productdata[0].product_images[0]}
                
                ></img>
                </NavLink>
              </div>
              <h6 className='ratedimage-title'>{ratingdata.productdata[0].product_title}</h6>
              </Col>
        }
    
      </Row>
      <Row>
      
        {isDesktopOrLaptop ?
          <Col lg={3} md={12}>
            <div className='ratedproduct-leftside'>
        
              <h2 className='ratedproduct-leftside-title'>What makes a good review</h2>
              <div className='ratedproduct-leftside-title-subtitle'>
                <h2 className='ratedproduct-leftside-title-subtitle-title'>Have you used this product?</h2>
                <div className='ratedproduct-leftside-title-subtitle-title-content'>Your review should be about your experience with the product.</div>
              </div>

              <div className='ratedproduct-leftside-title-subtitle'>
                <h2 className='ratedproduct-leftside-title-subtitle-title'>Why review a product?</h2>
                <div className='ratedproduct-leftside-title-subtitle-title-content'>Your valuable feedback will help fellow shoppers decide!</div>
              </div>
              <div className='ratedproduct-leftside-title-subtitle'>
                <h2 className='ratedproduct-leftside-title-subtitle-title'>How to review a product?</h2>
                <div className='ratedproduct-leftside-title-subtitle-title-content'>Your review should include facts. An honest opinion is always appreciated. If you have an issue with the product or service please contact us from the help centre.</div>
              </div>
            </div>


          </Col> : " "
        }

        <Col lg={9} md={12} className='rated-and-review-page'>
          <form onSubmit={handleSubmit}>
            <div className='ratedAndReview'>
              <div className='ratedProduct-main'>
                <div className='rate-product-maim'>
                <h1 className='ratedProduct-title'>Rate this Product</h1>
                 {error.ratingproduct && <span className='rating-error'>{error.ratingproduct}</span>}
                </div>
             
                <div className='ratedProduct-rating'>
                  {[...Array(5)].map((star, i) => {
                    const ratingValue = i + 1;

                    return (
                      <label key={i}>
                        <input
                          type="radio"
                          name="rating"
                          value={ratingValue}
                          onClick={() => handleRating(ratingValue)}
                          style={{ display: 'none' }}
                        />
                        <IoStarSharp

                          color={(ratingValue <= (hover || rating)) ? 'orange' : "lightgray"}
                          size={25}
                          onMouseEnter={() => setHover(ratingValue)}
                          onMouseLeave={() => setHover(0)}
                        />
                        <>

                        </>
                      </label>

                    );


                  })}
                  {(() => {
                    if (rating == 1) {
                      return <div className='starsStatus'>Bad</div>;
                    }
                    else if (rating == 2) {
                      return <div className='starsStatus'>Not Good</div>;
                    }
                    else if (rating == 3) {
                      return <div className='starsStatus'>Good</div>;
                    }
                    else if (rating == 4) {
                      return <div className='starsStatus'>Very Good</div>;
                    }
                    else if (rating == 5) {
                      return <div className='starsStatus'>Excellent</div>;
                    }
                  })()}



                </div>
                {
                  rating > 0 ?
                    <div className='ratedProduct-details'>Your rating has been saved</div> : ' '
                }
              </div>
              <div className='reviewProduct-main'>
                <h2 className='reviewProduct-title'>Review this product</h2>
                <div className='discriptionAndTitle'>
                  <div className='description-main'>
                    <div className='description-name'>Description</div>
                    {
                      comment.length <= 0 ? <div className='description-status'>Description can't be empty</div> : ''
                    }

                  </div>
                  <textarea className='description-inputbox' placeholder='Description...' value={comment} onChange={handleComment}>

                  </textarea>


                </div>
              </div>
              <div className='ratedproduct-images-'>
                <h2 className='ratedproduct-upload-image-title'><span>Upload images </span>
                  {
                    (message) &&
                    <span className='upload-images-only-five'>( Images size must be less than 200kb)</span>
                  }
                </h2>

              </div>

              <div className='related-review-submission'>
                <div className='rated-images-display' >


                  <input
                    type="file"
                    accept="image/*"
                    id='ratedphoto'
                    multiple
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                  <label for='ratedphoto'><BsCameraFill /></label>


                  {selectedImages.length > 0 &&
                    selectedImages.map((image, index) => (
                      <div key={index} className='upload-images-in-form'>

                        <img className='related-upload-photo'
                         referrerPolicy="no-referrer" 
                          src={URL.createObjectURL(image)}
                          alt={`Selected Image ${index}`}

                        />
                        <div onClick={() => removeImage(index)}>
                          <img referrerPolicy="no-referrer"  className='removeimages-in-ratedproducts' src='data:image/png;base64,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'></img>
                        </div>


                      </div>
                    ))
                  }

                </div>


              </div>

              {
                !isDesktopOrLaptop ?
                  <Row>
                    <div className='buttons-product-detaildiv'>
                      <div className='product-detail-buttongroup' onClick={handleSubmit}>
                        <div className='product-detail-button text-decoration-none'>
                          Submit Rating
                        </div>
                      </div>
                    </div>
                  </Row> :
                  <div className='related-submited-button' type="submit" onClick={handleSubmit}>Submit Rating</div>
              }

            </div>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default RatedProduct;